export function productsSelectedEqual(product1: any, product2: any) {
    return (
        product1.category_id === product2.category_id &&
        product1.product_id === product2.product_id &&
        JSON.stringify(product1.product_option) === JSON.stringify(product2.product_option) &&
        product1.price === product2.price &&
        product1.rate_tax === product2.rate_tax &&
        product1.lbl_printer_id === product2.lbl_printer_id &&
        product1.printer_id === product2.printer_id
    )
}